module.exports = __webpack_public_path__ + "static/media/process.29a0dc66.jpeg";